import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import ForgotPasswordPage from './ForgotPasswordPage';

const ForgotPasswordRoute: FuseRouteItemType = {
    path: 'forgot-password',
    element: <ForgotPasswordPage />,
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                },
                poweredBy: {
                    fixed: true
                }
            }
        }
    },
    auth: authRoles.onlyGuest
}

export default ForgotPasswordRoute;